import api from "@/libs/axios";
import { hasError } from "@/utils/utils";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    ngo_list: [],
    loading: false,
    isFiltering: false,
    ngoData: {},
  }),
  getters: {
    ngo_list(state) {
      return state.ngo_list;
    },

    ngoData(state) {
      return state.ngoData;
    },
    loading(state) {
      return state.loading;
    },
    isFiltering(state) {
      return state.isFiltering;
    },
  },

  mutations: {
    setNgoList(state, payload) {
      state.ngo_list = payload;
    },
    setNgoData(state, payload) {
      state.ngoData = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setFiltering(state, payload) {
      state.isFiltering = payload;
    },
  },

  actions: {
    async getNgoList({ commit }, payload) {
      // context.state.loading = true;
      commit("setFiltering", true);

      await api
        .post(
          ep.ngo_list,
          {},
          {
            params: {
              ...payload,
            },
          }
        )
        .then((res) => {
          commit("setNgoList", res.data.data);

          commit("setFiltering", false);
        })
        .catch((err) => {});
    },
    async fetchNgoData({ commit }, id) {
      commit("setLoading", true);
      try {
        const res = await api.post(ep.NGO_BY_ID(id));
        if (hasError(res)) throw res.status;
        commit("setNgoData", res.data.data);
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
